/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_22fefc60"]'><div><div>通过 wx:model 控制显隐藏，当前值：</div><cube-radio-group :col-num="(2)" :options="(options)" :value="radioVal" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","radioVal", "__mpx_event__", ["value"], undefined]])'/><cube-button @_click="showPicker">wx-model-picker</cube-button><cube-picker-modal :visible="isVisible" mpxModelEvent="toggle" ref="__mpx_ref_picker__" title="wx:model 控制" content="content 内容" :list="(dataList)" :selected-index="(selectedIndex)" @mpxModel='(e)=>__invoke(e, [["__model","isVisible", "__mpx_event__", ["value"], undefined]])'/></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_22fefc60"}'>
.demo-data
  margin-top: 10px
  padding: 10px 10px
  background-color: white
  border: 1px solid  white
  border-radius: 10px

  .key
    margin-bottom: 10px
    font-size: 16px
  .key-introduce
    margin-bottom: 10px
    line-height: 20px
  .value
    margin-bottom: 20px
    white-space: break-spaces
    .value-number
      margin-top: 20px
    .value-item
      display flex
      justify-content: space-between
      height: 25px
      line-height: 25px
      font-size: 15px
      .item-value
        margin-left: 10px
        white-space nowrap
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_22fefc60"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_22fefc60"}
  /** script content **/
  require("./wx-model-picker.mpx.js?isComponent&outputPath=components%2Fwx-model-picker22fefc60%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./wx-model-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fwx-model-picker22fefc60%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_22fefc60"],
    ctorType: "component",
    outputPath: "components/wx-model-picker22fefc60/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-radio-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/radio-group/index.mpx?isComponent&outputPath=components%2Findex467050cc%2Findex")),'cube-picker-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/picker-modal/index.mpx?isComponent&outputPath=components%2Findexa989b916%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>